import React, { useState } from "react";
import { Button, Icon, useToast } from "@chakra-ui/react";
import { ArrowsClockwise } from "@phosphor-icons/react";
import cr from "../../lib/request";
import useTrigger from "../../globalState/useTrigger";

type Props = {
  id: number;
};

export default function SwitchBlogPostOnlineStatus({ id }: Props) {
  const [loading, setLoading] = useState<boolean>(false);
  const toast = useToast();
  const { trigger, setTrigger } = useTrigger();

  const onUpdateStatus = () => {
    setLoading(true);
    const url = `api/blog/post/${id}/updateonlinestatus`;
    cr.post(url)
      .then((r) => {
        if (r.status === 200) {
          toast({
            title: r.data.message,
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          setTrigger(!trigger);
        }
      })
      .catch((e) => {
        console.log(e);
        toast({
          title: e.response?.data?.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Button
        leftIcon={<Icon as={ArrowsClockwise} fontSize={16} />}
        colorScheme="ap"
        size={"sm"}
        className="clicky"
        variant={"outline"}
        onClick={onUpdateStatus}
        isLoading={loading}
      >
        Status
      </Button>
    </>
  );
}
